


















































import Vue from "vue"

import {VueEditor} from "vue2-editor"
import ImageResize from "quill-image-resize-module"
import {News} from "@/model/entity/news/news"
import {newsService} from "@/model/service/news/news-service"
import "quill/dist/quill.core.css"

export interface INewsEditorMethods extends Vue {
  editNews(entity: News): void

  addNews(): void
}

export default Vue.extend({
  components: {
    VueEditor
  },
  data() {
    return {
      newsId: null as any,
      isInQuery: false,
      news: new News(),
      newsService: newsService,
      form: {
        title: null,
        publishedDate: null,
        active: false
      },
      toolbar: [
        [{header: [false, 1, 2, 3, 4, 5, 6]}],
        ["bold", "italic", "underline", "strike"],
        [{align: ""}, {align: "center"}, {align: "right"}],
        ["blockquote", "code-block"],
        [{list: "ordered"}, {list: "bullet"}, {list: "check"}],
        [{indent: "-1"}, {indent: "+1"}],
        [{color: []}, {background: []}],
        ["link", "image"]
      ],
      customModulesForEditor: [{alias: "imageResize", module: ImageResize}],
      editorSettings: {
        modules: {
          imageResize: {}
        }
      }
    }
  },
  methods: {
    callFunction() {
      if (this.$route.params.id !== undefined) {
        this.editNews()
      } else {
        this.addNews()
      }
    },
    addNews() {
      this.news = new News()
    },
    editNews() {
      const vm = this
      this.newsId = this.$route.params.id
      this.newsService.getById(this.newsId).then((response: any) => {
        vm.news = JSON.parse(JSON.stringify(response.data))
      })
    },
    save() {
      const vm = this
      vm.startLoad()
      this.newsService
        .createOrModify(vm.news)
        .then(() => {
          vm.endLoad()
          vm.$router.push({path: "/record_news"})
        })
        .catch(() => {
          vm.endLoad()
        })
    },
    changeRoute() {
      this.$router.push({path: `/record_news`})
    }
  },
  created() {
    this.callFunction()
  }
})
